import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

const client = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
});

// Turn absolute /api/images/... URLs into fully-qualified ones for <img> tags
export function absUrl(path) {
  if (!path) return null;
  if (path.startsWith("http")) return path;
  return `${BACKEND_URL}${path}`;
}

export const api = {
  get: async (path, config) => (await client.get(path, config)).data,
  post: async (path, body, config) => (await client.post(path, body, config)).data,
};

export { BACKEND_URL };
